import {Component, OnDestroy, OnInit} from '@angular/core';
import {PrimeNGConfig} from "primeng/api";
import {Router, RouterOutlet} from "@angular/router";
import {LoaderComponent} from "./@admin/components/loader/loader.component";
import {ToastModule} from "primeng/toast";
import {MsalBroadcastService, MsalService} from "@azure/msal-angular";
import {TitleMediatorService} from "./@admin/services/title/title-mediator.service";
import {Subject, takeUntil} from "rxjs";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {LoginComponent} from "./modules/auth/login/login.component";
import {ButtonModule} from "primeng/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RippleModule} from "primeng/ripple";
import {filter} from "rxjs/operators";
import {EventMessage, EventType, InteractionStatus} from "@azure/msal-browser";
import {AZURE_TOKEN_KEY, LocalStorageUtils} from "./@admin/utils/methods/local-storage.utils";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, ToastModule, NgIf, LoginComponent, ButtonModule, FormsModule, ReactiveFormsModule, RippleModule, NgForOf, NgClass],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'AppraiserPro.UI';
  private readonly _destroying$ = new Subject<void>();

  constructor(private primengConfig: PrimeNGConfig, private titleMediatorService: TitleMediatorService,
              private _router: Router, private msalService: MsalService, private msalBroadcastService: MsalBroadcastService) {
  }

  ngOnInit(): void {
    // Manage Azure Login Redirection
    this.manageAzureLoginRedirection();
    this.primengConfig.ripple = true;
    this.titleMediatorService.init();

    this.msalService.instance.enableAccountStorageEvents(); // Enable account storage events

    // Handle account added or removed events
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
        takeUntil(this._destroying$)
      )
      .subscribe((_) => {
        if (this.msalService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        }
      });

    // Handle in-progress events
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  checkAndSetActiveAccount(): void {
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  /**
   * If User is Logged In then Navi gate to "Counties" Page.
   * */
  private manageAzureLoginRedirection(): void {
    this.msalService.handleRedirectObservable().subscribe({
      next: (_) => {
        if (_ != null && _.account != null) {
          this.msalService.instance.setActiveAccount(_.account);
          LocalStorageUtils.setAccessToken(AZURE_TOKEN_KEY, _.accessToken);
          this._router.navigate(['manage-portals']).then();
        }
      },
    });
  }

  protected readonly Array = Array;
}
